<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Tender Invitation Email Template</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()">
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col">
            <div class="template-wrap">
                <textarea class="form-control">{{ invitationHtml }}</textarea>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-light"
            [copy-clipboard]="this.invitationHtml"
            (copied)="copy($event)"><i class="fas fa-copy me-1" aria-hidden="true"></i> Copy Invitation
    </button>
    <button type="button" class="btn btn-light" (click)="close()">Close</button>
</div>
